module.exports = __webpack_public_path__ + "static/media/abyss.b98b630a.jpg";